var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashHPerfomanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.76334 3.82082C3.67815 4.90601 3.00281 6.33389 2.85239 7.86119C2.70196 9.38848 3.08576 10.9207 3.93838 12.1967C4.79101 13.4728 6.0597 14.4137 7.52831 14.8592C8.99691 15.3047 10.5745 15.2272 11.9924 14.6399C13.4103 14.0526 14.5806 12.9918 15.3041 11.6384C16.0275 10.2849 16.2593 8.72246 15.9599 7.21726C15.6605 5.71207 14.8484 4.35725 13.6621 3.38365C12.4758 2.41006 10.9886 1.87793 9.4539 1.87793",
    stroke: "#05073C",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4539 8.51121L5.90754 4.96484",
    stroke: "#05073C",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4539 1.77319V3.54637",
    stroke: "#05073C",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8374 8.51123L14.4188 8.51123",
    stroke: "#05073C",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4539 13.4761V14.8946",
    stroke: "#05073C",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48899 8.51123L3.07044 8.51123",
    stroke: "#05073C",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashHPerfomanceIcon);
export default __webpack_public_path__ + "static/media/dash-h-perfomance-icon.b5f032c50509203df31ddd9d83df54fb.svg";
export { ForwardRef as ReactComponent };